import isEmpty from '@automator/utilities/is-empty';

/**
 * Returns the value of a parameter in the URL
 *
 * @param {String} url       The URL
 * @param {String} parameter The parameter key
 * @return {String}           The parameter value
 */
const getURLParameter = ( url = '', parameter = '' ) => {
	// If the URL is empty, use the site URL
	if ( isEmpty( url ) ) {
		url = window.location.href;
	}

	// Convert it to an URL object
	url = new URL( url );

	// Get parameter
	return url.searchParams.get( parameter );
};

export default getURLParameter;
